import { render, staticRenderFns } from "./WeekCalendar.vue?vue&type=template&id=4236ae8c&scoped=true"
import script from "./WeekCalendar.vue?vue&type=script&lang=ts"
export * from "./WeekCalendar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4236ae8c",
  null
  
)

export default component.exports